import { render } from "./PpcBudgetAllocationCircle.vue?vue&type=template&id=1cb9d2b4&scoped=true"
import script from "./PpcBudgetAllocationCircle.vue?vue&type=script&lang=js"
export * from "./PpcBudgetAllocationCircle.vue?vue&type=script&lang=js"

import "./PpcBudgetAllocationCircle.vue?vue&type=style&index=0&id=1cb9d2b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb9d2b4"]])

export default __exports__